import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/verified.png';
const _hoisted_1 = { class: "simplePage" };
const _hoisted_2 = { class: "anchor-bottom" };
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EligibilityVerifiedPage',
    setup(__props) {
        const router = useRouter();
        useAppState();
        useAuth();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0",
                    bgcolor: "transparent"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("h1", null, [
                        _createTextVNode("You're in!"),
                        _createElementVNode("br"),
                        _createTextVNode("Welcome to Money Guided")
                    ], -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("img", {
                        class: "heroImg",
                        src: _imports_0
                    }, null, -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("p", null, "Before we go any further, let's get to know you.", -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(MGButton, {
                            text: "Continue",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push({ path: '/personaldetails' }))),
                            arrow: true
                        })
                    ])
                ])
            ], 64));
        };
    }
});
